import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VpService {

  constructor(protected http: HttpClient) { }

  list(): Observable<any[]> {
    return this.http.get<any[]>('/vps');
  }

  import(formData): Observable<any[]> {
    return this.http.post<any[]>('/vps/import', formData);
  }
}
